import React from "react";
import Form from "./common/form";
import { resetPassword, confirmResetPassword } from "aws-amplify/auth";
import Swoosh from "../Images/5.jpg";
import "../css/form.css";

class ResetPassword extends Form {
  state = {
    data: {
      code: "",
      email: "",
      password: "",
      confirmPassword: "",
    },
    codeSent: false,
    confirmed: false,
    isConfirming: false,
    isSdendingCode: false,
    errors: {},
  };

  validateEmailForm() {
    const { email } = this.state.data;
    return email.length > 0 && email.includes("@") && email.includes(".");
  }

  validateResetForm() {
    const { code, password, confirmPassword } = this.state.data;
    return (
      code.length > 0 && password.length > 0 && password === confirmPassword
    );
  }

  validateCompleteSignUpFormLength() {
    const { password } = this.state.data;
    return password.length > 7;
  }

  validateCompleteSignUpFormMatch() {
    const { password, confirmPassword } = this.state.data;
    return password.length > 0 && password === confirmPassword;
  }

  validateCompleteSignUpFormNumber() {
    const { password } = this.state.data;
    return /\d/.test(password);
  }

  validateCompleteSignUpFormSpecialChar() {
    const { password } = this.state.data;
    return /[$&+,:;=?@#|'<>.^*()%!_-]/.test(password);
  }

  validateCompleteSignUpFormUpper() {
    const { password } = this.state.data;
    return /[A-Z]/.test(password);
  }

  validateCompleteSignUpFormLower() {
    const { password } = this.state.data;
    return /[a-z]/.test(password);
  }

  handleSendCodeClick = async (event) => {
    event.preventDefault();

    this.setState({ isSdendingCode: true });

    try {
      await resetPassword({ username: this.state.data.email });
      this.setState({ codeSent: true });
    } catch (error) {
      this.onError(error);
      this.setState({ isSdendingCode: true });
      alert(error.message);
    }
  };

  handleConfirmClick = async (event) => {
    event.preventDefault();
    const { email, code, password } = this.state.data;

    this.setState({ IsConfirming: true });

    try {
      await confirmResetPassword({ username: email, confirmationCode: code, newPassword: password });
      this.setState({ Confirmed: true });
      window.location = "proposals";
    } catch (error) {
      this.onError(error);
      this.setState({ IsConfirming: true });
    }
  };

  renderRequestCodeForm = () => {
    return (
      <form
        onSubmit={this.handleSendCodeClick}
        style={{ minWidth: "300px", maxWidth: "400px" }}
      >
        <h1>Reset Password</h1>
        <h6>Enter your email to get a verification code</h6>
        {this.renderInput("email", "Email")}
        <button
          style={{ width: "100%" }}
          type={"submit"}
          className={
            this.validateEmailForm() ? "btn btn-primary" : "btn btn-secondary"
          }
          disabled={!this.validateEmailForm()}
        >
          Send Code
        </button>
      </form>
    );
  };

  renderConfirmationForm = () => {
    return (
      <form
        onSubmit={this.handleConfirmClick}
        style={{ minWidth: "300px", maxWidth: "400px" }}
      >
        <h1>Reset Password</h1>
        {this.renderInput("code", "Confirmation Code:")}
        <h6>Please check your email for the code.</h6>
        <div className="dropdown-divider"></div>
        {this.renderInput("password", "Password", "password")}
        {this.renderInput("confirmPassword", "Confirm Password", "password")}
        <button
          style={{ width: "100%" }}
          type={"submit"}
          className={
            this.validateCompleteSignUpFormMatch() &&
            this.validateCompleteSignUpFormLength() &&
            this.validateCompleteSignUpFormNumber() &&
            this.validateCompleteSignUpFormSpecialChar() &&
            this.validateCompleteSignUpFormUpper() &&
            this.validateCompleteSignUpFormLower()
              ? "btn btn-primary"
              : "btn btn-secondary"
          }
          disabled={
            !this.validateCompleteSignUpFormMatch() &&
            !this.validateCompleteSignUpFormLength() &&
            !this.validateCompleteSignUpFormNumber() &&
            !this.validateCompleteSignUpFormSpecialChar() &&
            !this.validateCompleteSignUpFormUpper() &&
            !this.validateCompleteSignUpFormLower()
          }
        >
          Go to Login Page
        </button>
        <div>
          <h4 style={{ marginTop: "10px" }}>Password Requirements:</h4>
          <div>
            <span
              className={
                this.validateCompleteSignUpFormLength()
                  ? "dot-success"
                  : "dot-requred"
              }
            ></span>{" "}
            Requires at least a length of 8 characters
          </div>
          <div>
            <span
              className={
                this.validateCompleteSignUpFormNumber()
                  ? "dot-success"
                  : "dot-requred"
              }
            ></span>{" "}
            Requires at least a number
          </div>
          <div>
            <span
              className={
                this.validateCompleteSignUpFormLower()
                  ? "dot-success"
                  : "dot-requred"
              }
            ></span>{" "}
            Requires at least a lower case character
          </div>
          <div>
            <span
              className={
                this.validateCompleteSignUpFormUpper()
                  ? "dot-success"
                  : "dot-requred"
              }
            ></span>{" "}
            Requires at least an UPPER case character
          </div>
          <div>
            <span
              className={
                this.validateCompleteSignUpFormSpecialChar()
                  ? "dot-success"
                  : "dot-requred"
              }
            ></span>{" "}
            Requires at least a special character
          </div>
          <div>
            <span
              className={
                this.validateCompleteSignUpFormMatch()
                  ? "dot-success"
                  : "dot-requred"
              }
            ></span>{" "}
            Passwords match
          </div>
        </div>
      </form>
    );
  };

  onError = (error) => {
    let errorInfo = {};
    let message = error.toString();

    // Auth errors
    if (!(error instanceof Error) && error.message) {
      errorInfo = error;
      message = error.message;
      error = new Error(message);
      // API errors
    } else if (error.config && error.config.url) {
      errorInfo.url = error.config.url;
    }

    alert(message);
  };

  render() {
    return (
      <React.Fragment>
        <div>
          <img
            src={Swoosh}
            alt="Swoosh.png"
            style={{
              height: "calc(100vh - 50px)",
              position: "fixed",
              width: "100vw",
              filter: "brightness(80%)",
            }}
          />
          <div className="center">
            <div className="card" style={{ width: "25rem" }}>
              <div className="card-body">
                {!this.state.codeSent
                  ? this.renderRequestCodeForm()
                  : !this.state.confirmed
                  ? this.renderConfirmationForm()
                  : this.renderSuccessMessage()}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ResetPassword;
